import { enumBoxShapes } from "../constants";
import { QXMLObject } from "./QXMLObject";
import { removeDiacritics } from "../utils/removeDiacritics";
import { TruncateText } from "../utils/TruncateText";
import { XML_AddArc } from "../utils/XML_AddArc";
import { XML_AddClipRect } from "../utils/XML_AddClipRect";
import { XML_AddPair } from "../utils/XML_AddPair";
import { XML_Cmd1 } from "../utils/XML_Cmd1";
import { XML_Cmd2 } from "../utils/XML_Cmd2.js";
import { XML_ConvertDPI } from "../utils/XML_ConvertDPI";
import { Globals } from "./Globals";
import { QStream } from "./QStream";
import { removeInvalidChars } from "../utils/removeInvalidChars";
import { XML_Param6 } from "../utils/XML_Param6";

export class QXMLDoc extends QXMLObject {
  constructor() {
    super();
    this.fHeight = null;
    this.fStream = null;
    this.fIncludeSCArrows = false;
    this.fCheckPoint = null;
    this.fDocType = null;
  }

  InitXMLDoc(width, height, scaleFactor, docType) {
    this.fDocType = docType;
    Globals._scaleFactor = scaleFactor;
    this.SetXMLElementName("xmldoc");

    var s = this.ResetStream();
    //var s = new QStream();
    //s.InitStream();
    //this.fStream = s;

    var elementName = this.GetXMLElementName();
    this.OutputElementHead(s, elementName);
    width = XML_ConvertDPI(width);
    height = XML_ConvertDPI(height);
    this.fHeight = height;

    this.OutputElementPair("bounds", width, height, s);
  }

  ResetStream() {
    var s = new QStream();
    s.InitStream();
    this.fStream = s;
    return s;
  }

  GetDocType() {
    return this.fDocType;
  }

  SupportsClip() {
    return true;
  }

  PreJustifyText() {
    return true;
  }

  StartPage(pageNum, bookmark, divSwitch) {
    var s = this.fStream;
    this.OutputElementHead(s, "pn");
    if (divSwitch != null) {
      divSwitch = removeDiacritics(divSwitch);
      divSwitch = removeInvalidChars(divSwitch);
      this.OutputSimpleElement("bm", divSwitch, s);
    }
    if (bookmark != null) {
      bookmark = removeDiacritics(bookmark);
      bookmark = removeInvalidChars(bookmark);
      this.OutputSimpleElement("bm", bookmark, s);
      this.fIncludeSCArrows = true;
    }
  }

  EndPage() {
    this.OutputElementTail(this.fStream, "pn");
  }

  StartBookmarks() {
    var s = this.fStream;
    this.OutputElementHead(s, "bookmarks");
  }

  EndBookmarks() {
    this.OutputElementTail(this.fStream, "bookmarks");
  }

  ConvertY(yVal) {
    return this.fHeight - yVal;
  }

  AddClipRect(clipRect, layer) {
    XML_AddClipRect(clipRect, this, layer);
  }

  UseBoundingRect() {
    return false;
  }

  AddBoundingRect(boundingRect) {}

  Close() {
    var elementName = this.GetXMLElementName();
    this.OutputElementTail(this.fStream, elementName);
  }

  GetStream() {
    return this.fStream;
  }

  JoinStream() {
    var jStream = this.fStream.JoinStream();
    return jStream;
  }

  JoinStream2() {
    var jStream = this.fStream.JoinStream2();
    return jStream;
  }

  JoinStream3() {
    var jStream = this.fStream.JoinStream3();
    return jStream;
  }

  CheckPoint() {
    this.fCheckPoint = this.fStream.StreamLen();
  }

  Rollback() {
    this.fStream.TruncateSteam(this.fCheckPoint);
  }

  ClipText(theText, fontString, clipRect) {
    theText = theText.replace("\n", "");
    if (!clipRect) return theText;
    var availableWidth = clipRect.fRight - clipRect.fLeft;
    theText = TruncateText(theText, fontString, availableWidth);
    return theText;
  }

  DoFillRect(x, y, width, height, fillColor, fillColor2) {
    var s = this.GetStream();
    this.OutputElementHead(s, "ph");
    XML_AddPair(x, y, "mt", this);
    XML_AddPair(width, 0, "rt", this);
    XML_AddPair(0, -height, "rt", this);
    XML_AddPair(-width, 0, "rt", this);
    XML_AddPair(0, height, "rt", this);
    this.OutputElementTail(s, "ph");
    if (fillColor2 != null) {
      XML_Param6("cm", "grd", fillColor, fillColor2, x, y, height, this);
    } else {
      XML_Cmd1("fi", fillColor, this);
    }
  }

  CreatePath(bounds, boxShape) {
    var r = bounds;
    var s = this.GetStream();

    this.OutputElementHead(s, "ph");
    switch (boxShape) {
      case enumBoxShapes.rectangle:
        XML_AddPair(r.fLeft, r.fTop, "mt", this);
        XML_AddPair(r.fRight, r.fTop, "lt", this);
        XML_AddPair(r.fRight, r.fBottom, "lt", this);
        XML_AddPair(r.fLeft, r.fBottom, "lt", this);
        XML_AddPair(r.fLeft, r.fTop, "lt", this);
        break;
      case enumBoxShapes.snipCornerRectangle:
        XML_AddPair(r.fLeft, r.fTop, "mt", this);
        XML_AddPair(r.fRight - r.fCornerRadius, r.fTop, "lt", this);
        XML_AddPair(r.fRight, r.fTop - r.fCornerRadius, "lt", this);
        XML_AddPair(r.fRight, r.fBottom, "lt", this);
        XML_AddPair(r.fLeft, r.fBottom, "lt", this);
        XML_AddPair(r.fLeft, r.fTop, "lt", this);
        break;
      case enumBoxShapes.roundRectangle:
        XML_AddPair(r.fLeft + r.fCornerRadius, r.fBottom, "mt", this);
        XML_AddPair(r.fRight - r.fCornerRadius, r.fBottom, "lt", this);
        XML_AddArc(
          r.fRight - r.fCornerRadius,
          r.fBottom,
          r.fRight,
          r.fBottom,
          r.fRight,
          r.fBottom + r.fCornerRadius,
          this
        );
        XML_AddPair(r.fRight, r.fTop - r.fCornerRadius, "lt", this);
        XML_AddArc(
          r.fRight,
          r.fTop - r.fCornerRadius,
          r.fRight,
          r.fTop,
          r.fRight - r.fCornerRadius,
          r.fTop,
          this
        );
        XML_AddPair(r.fLeft + r.fCornerRadius, r.fTop, "lt", this);
        XML_AddArc(
          r.fLeft + r.fCornerRadius,
          r.fTop,
          r.fLeft,
          r.fTop,
          r.fLeft,
          r.fTop - r.fCornerRadius,
          this
        );
        XML_AddPair(r.fLeft, r.fBottom + r.fCornerRadius, "lt", this);
        XML_AddArc(
          r.fLeft,
          r.fBottom + r.fCornerRadius,
          r.fLeft,
          r.fBottom,
          r.fLeft + r.fCornerRadius,
          r.fBottom,
          this
        );
        break;
      case enumBoxShapes.roundSnipCornerRectangle:
        XML_AddPair(r.fLeft, r.fTop, "mt", this);
        XML_AddPair(r.fRight - r.fCornerRadius, r.fTop, "lt", this);
        XML_AddArc(
          r.fRight - r.fCornerRadius,
          r.fTop,
          r.fRight,
          r.fTop,
          r.fRight,
          r.fTop - r.fCornerRadius,
          this
        );
        XML_AddPair(r.fRight, r.fBottom, "lt", this);
        XML_AddPair(r.fLeft, r.fBottom, "lt", this);
        XML_AddPair(r.fLeft, r.fTop, "lt", this);
        break;
    }

    this.OutputElementTail(s, "ph");
  }

  CreateTriPath2(sx, sy, ex, ey) {
    var s = this.GetStream();
    this.OutputElementHead(s, "ph");
    XML_AddPair(ex, sy, "mt", this);
    XML_AddPair(ex, ey, "lt", this);
    XML_AddPair(sx, sy, "lt", this);
    XML_AddPair(ex, sy, "lt", this);
    this.OutputElementTail(s, "ph");
  }

  DrawSmallArrow(x0, y0, x1, y1, x2, y2, style) {
    var stroke = "#FFFFFF";
    var fill = "#000000";
    if (style != null) {
      stroke = style.buttonStroke;
      fill = style.buttonFill;
    }
    var s = this.GetStream();
    this.OutputElementHead(s, "ph");
    XML_AddPair(x0, y0, "mt", this);
    XML_AddPair(x1, y1, "lt", this);
    XML_AddPair(x2, y2, "lt", this);
    XML_AddPair(x0, y0, "lt", this);
    this.OutputElementTail(s, "ph");
    XML_Cmd2("stk", stroke, 2, this);
    XML_Cmd1("fi", fill, this);
  }

  DrawLargeArrow(x0, y0, x1, y1, x2, y2, x3, x4, fillColor) {
    var s = this.GetStream();
    this.OutputElementHead(s, "ph");
    XML_AddPair(x0, y0, "mt", this);
    XML_AddPair(x0, y1, "lt", this);
    XML_AddPair(x1, y1, "lt", this);
    XML_AddPair(x2, y2, "lt", this);
    XML_AddPair(x3, y1, "lt", this);
    XML_AddPair(x4, y1, "lt", this);
    XML_AddPair(x4, y0, "lt", this);
    XML_AddPair(x0, y0, "lt", this);
    this.OutputElementTail(s, "ph");
    XML_Cmd2("stk", "#000000", 1, this);
    XML_Cmd1("fi", fillColor, this);
  }

  CreateTriPath(sx, sy, ex, ey, r, boxShape, triPosition) {
    var s = this.GetStream();
    this.OutputElementHead(s, "ph");

    if (triPosition == 0) {
      switch (boxShape) {
        case enumBoxShapes.rectangle:
          XML_AddPair(ex, sy, "mt", this);
          XML_AddPair(ex, ey, "lt", this);
          XML_AddPair(sx, sy, "lt", this);
          XML_AddPair(ex, sy, "lt", this);
          break;
        case enumBoxShapes.snipCornerRectangle:
          XML_AddPair(sx, sy, "mt", this);
          XML_AddPair(ex - r, sy, "lt", this);
          XML_AddPair(ex, sy - r, "lt", this);
          XML_AddPair(ex, ey, "lt", this);
          XML_AddPair(sx, sy, "lt", this);
          break;
        case enumBoxShapes.roundRectangle:
        case enumBoxShapes.roundSnipCornerRectangle:
          XML_AddPair(sx, sy, "mt", this);
          XML_AddPair(ex - r, sy, "lt", this);
          XML_AddArc(ex - r, sy, ex, sy, ex, sy - r, this);
          XML_AddPair(ex, ey, "lt", this);
          XML_AddPair(sx, sy, "lt", this);
          break;
      }
    } else {
      switch (boxShape) {
        case enumBoxShapes.rectangle:
        case enumBoxShapes.snipCornerRectangle:
        case enumBoxShapes.roundSnipCornerRectangle:
          XML_AddPair(sx, sy, "mt", this);
          XML_AddPair(ex, sy, "lt", this);
          XML_AddPair(sx, ey, "lt", this);
          XML_AddPair(sx, sy, "lt", this);
          break;
        case enumBoxShapes.roundRectangle:
          XML_AddPair(sx + r, sy, "mt", this);
          XML_AddPair(ex, sy, "lt", this);
          XML_AddPair(sx, ey, "lt", this);
          XML_AddPair(sx, sy - r, "lt", this);
          XML_AddArc(sx, sy - r, sx, sy, sx + r, sy, this);
          break;
      }
    }

    this.OutputElementTail(s, "ph");
  }
}
